import React from 'react';
import { Box, TextField, CircularProgress, List, ListItemButton,
  ListItemText, Typography, InputAdornment, Chip,
  IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import { ClearIcon } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';

const CustomerSearch = ({
  searchInput,
  setSearchInput,
  searchResults,
  searchLoading,
  selectedCustomer,
  onSelectResult,
}) => {
  const { t } = useTranslation();
  const showDropdown = searchInput.trim().length >= 4;

  const clearInput = () => {
    setSearchInput('');
  };

  return (
    <Box sx={{ position: 'relative' }}>

      {selectedCustomer && (
        <Chip
          icon={<PersonIcon />}
          label={`${selectedCustomer.firstName} ${selectedCustomer.lastName} — ${selectedCustomer.email}`}
          onDelete={() => onSelectResult(null)}
          color="primary"
          variant="outlined"
          sx={{ mb: 2 }}
        />
      )}

      {
        !selectedCustomer && (
          <TextField
            fullWidth
            size="small"
            placeholder={t('varausModal.components.searchCustomer')}
            value={searchInput}
            onChange={e => setSearchInput(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {searchLoading
                    ? <CircularProgress size={18} />
                    : <SearchIcon fontSize="small" color="action" />}
                </InputAdornment>
              ),
              endAdornment: searchInput && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={clearInput} edge="end">
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )
      }

      {/* Dropdown */}
      {showDropdown && (
        <Box sx={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          zIndex: 10,
          mt: 0.5,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          bgcolor: 'background.paper',
          boxShadow: 3,
          maxHeight: 280,
          overflowY: 'auto',
        }}
        >
          {searchResults.length > 0
            ? (
                <List dense disablePadding sx={{ py: 1 }}>
                  {searchResults.map(customer => (
                    <ListItemButton
                      key={customer.asiakasId}
                      onClick={() => onSelectResult(customer)}
                      divider
                    >
                      <ListItemText
                        primary={`${customer.firstName} ${customer.lastName}`}
                        secondary={
                          [customer.email, customer.phone, customer.company]
                            .filter(Boolean)
                            .join('\n')
                        }
                        slotProps={{ secondary: { sx: { whiteSpace: 'pre-line' } } }}
                      />
                    </ListItemButton>
                  ))}
                </List>
              )
            : !searchLoading && (
                <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                  {t('varausModal.components.customerNotFound')}
                </Typography>
              )}
        </Box>
      )}
    </Box>
  );
};

export default CustomerSearch;
